








import Debug from 'debug'
import { Component, Vue, Watch } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import { TrackingService } from '@/app/tracking/tracking-service';
import {
  CourseEvent,
  CourseOpenedEventName,
  TimeSpentInCourseEventName,
  CourseLeftEventName
} from '@/app/aspect/events/course-events';
import { setDocumentTitle } from '@/app/shared/utils/document-utils';
import aspectStoreModule from '@/app/aspect/apsect-state';
import sectionStoreModule from '@/app/statistics/state/section-state';
import HeaderComponent from '@/app/shared/components/header-component.vue';
import NotificationComponent from '@/app/notification/ui/notification-component.vue';
import { createCommand } from '@/app/tracking/api';
import { CloseCourseCommand } from '@/app/course/tracking/api';

const SPENT_TIME_SAVING_PERIOD_SECONDS = 5;

const debug = Debug('layout-component');

@Component({
  components: {
    HeaderComponent,
    NotificationComponent
  }
})
export default class LayoutComponent extends Vue {
  @lazyInject(EventStreamSymbol)
  private eventStream: EventStream;

  @lazyInject(TrackingService)
  private trackingService: TrackingService;

  public get selectedAspectInstanceId(): string|null {
    return aspectStoreModule.selectedAspectInstanceId;
  }

  public mounted(): void {
    setDocumentTitle();
    this.tryUseThemeFavicon()

    this.eventStream.dispatch({
      name: CourseOpenedEventName,
      payload: {
        courseId: aspectStoreModule.courseId
      }
    } as CourseEvent);

    // TODO: turned off for the time being
    // this.setupSpentTime();
  }

  // TODO: obsolete, remove
  private tryUseThemeFavicon() {
    // try {
    //   const uri = require('@/assets/images/' + process.env.VUE_APP_THEME_NAME + '/favicon.ico');
    //   debug('changing favicon to theme\'s one', uri);
    //   changeFavicon(uri);
    // }
    // catch (e) {
    //   debug(`favicon not found for theme ${process.env.VUE_APP_THEME_NAME}, skipping`, e.toString());
    // }
  }

  public onGlobalClick(e: any) {
    let $element: any = $(e.target);
    let isLink: boolean = e.target.tagName.toLowerCase() === 'a';

    if (!isLink) {
      $element = $element.closest('a');
      isLink = $element.length > 0;
    }

    if (!isLink) {
      return;
    }

    const href: string = $element.attr('href');

    if (!href) {
      return;
    }

    const hrefItems: string[] = href.split('?');
    if (hrefItems.length < 2) {
      return;
    }

    const queryParameters: string[] = (hrefItems[1]).split('&');
    for (const param of queryParameters) {
      const [key, value] = param.split('=');
      if (key === 'section' && value) {
        this.setNavigatedSectionId(value);
      }
    }
  }

  @Watch('selectedAspectInstanceId')
  public onSelectedAspectInstanceIdChanged(): void {
    setDocumentTitle();
  }

  public created(): void {
    this.listenCloseWindow();
  }

  private setNavigatedSectionId(sectionId: string): void {
    sectionStoreModule.setNavigatedSectionId(sectionId);
  }

  private setupSpentTime(): void {
    setInterval(
      () => this.eventStream.dispatch({
        name: TimeSpentInCourseEventName,
        payload: {
          courseId: aspectStoreModule.courseId
        }
      } as CourseEvent),
      SPENT_TIME_SAVING_PERIOD_SECONDS * 1000
    );

    $(window).on('beforeunload', () => {
      // TODO: only if really left
      this.eventStream.dispatch({
        name: CourseLeftEventName,
        payload: {
          courseId: aspectStoreModule.courseId
        }
      } as CourseEvent);
      return 'Valóban bezárja a tananyagot?';
    });
  }

  private listenCloseWindow() {
    window.addEventListener('beforeunload', async (e) => {
      this.trackingService.execute(createCommand<CloseCourseCommand>('close-course', {}));
      await this.trackingService.finish();
    });
  }
}
